import React, {Component} from 'react';
import { List } from 'semantic-ui-react';
import ArtifactItemDetailImage from './item-detail-components/ArtifactItemDetailImage';
import QuestRewardDetail from './item-detail-components/QuestRewardDetail';
import QuestItemDetail from './item-detail-components/QuestItemDetail';
import CraftedItemDetail from './item-detail-components/CraftedItemDetail';
import CraftingIngredientDetail from './item-detail-components/CraftingIngredientDetail';
import VendorItemDetail from './item-detail-components/VendorItemDetail';

export default class ItemDetailCell extends Component {
    render() {
        const {item} = this.props;

        const artifactElement = item.Collections ? <List.Item><ArtifactItemDetailImage item={item} /></List.Item> : null;
        const craftedElement = item.CreatedBy ? <List.Item><CraftedItemDetail item={item} /></List.Item> : null;
        const craftingIngredientElement = item.IngredientIn ? <List.Item><CraftingIngredientDetail item={item} /></List.Item> : null;
        const questElement = item.QuestItems ? <List.Item><QuestItemDetail item={item} /></List.Item> : null;
        const questRewardElement = item.QuestRewards ? <List.Item><QuestRewardDetail item={item} /></List.Item> : null;
        const vendorElement = item.SoldBy ? <List.Item><VendorItemDetail item={item}/></List.Item> : null;

        return (
            <List horizontal={true}>
                {artifactElement}
                {craftedElement}
                {craftingIngredientElement}
                {questElement}
                {questRewardElement}
                {vendorElement}
            </List>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/index/ItemDetailCell.jsx